// extracted by mini-css-extract-plugin
export var carrierTab = "_3r-0";
export var carrierTabActive = "_3r-1 _3r-0";
export var carrierTabInactive = "_3r-2 _3r-0";
export var carrierTabLabel = "_3r-3";
export var carrierTabLabelActive = "_3r-4 _3r-3";
export var carrierTabLabelInactive = "_3r-5 _3r-3";
export var carrierTabPercentage = "_3r-6";
export var carrierTabPercentageActive = "_3r-7 _3r-6";
export var carrierTabPercentageInactive = "_3r-8 _3r-6";
export var carrierTabWinnable = "_3r-9";
export var carrierTabWinnableActive = "_3r-a _3r-9";
export var carrierTabWinnableInactive = "_3r-b _3r-9";
export var comparisonContainer = "_3r-d";
export var missingRateButton = "_3r-n";
export var missingRateButtonActive = "_3r-o _3r-n";
export var missingRateButtonInactive = "_3r-p _3r-n";
export var missingRateButtonLabel = "_3r-q";
export var missingRateButtonLabelActive = "_3r-r _3r-q";
export var missingRateButtonLabelInactive = "_3r-s _3r-q";
export var sidebar = "_3r-c";
export var strategyButton = "_3r-e";
export var strategyButtonActive = "_3r-f _3r-e";
export var strategyButtonDescription = "_3r-k";
export var strategyButtonDescriptionActive = "_3r-l _3r-k";
export var strategyButtonDescriptionInactive = "_3r-m _3r-k";
export var strategyButtonInactive = "_3r-g _3r-e";
export var strategyButtonLabel = "_3r-h";
export var strategyButtonLabelActive = "_3r-i _3r-h";
export var strategyButtonLabelInactive = "_3r-j _3r-h";
export var unitToggleButton = "_3r-t";
export var unitToggleButtonActive = "_3r-u _3r-t";
export var unitToggleButtonInactive = "_3r-v _3r-t";
export var unitToggleButtonLabel = "_3r-w";
export var unitToggleButtonLabelActive = "_3r-x _3r-w";
export var unitToggleButtonLabelInactive = "_3r-y _3r-w";